import type { TOC } from '@ember/component/template-only'
import { ErrorsApplicationErrorPage } from 'teacher-ui-client/components/errors/application-error-page'
import { FlashQueue } from 'teacher-ui-client/components/flash-queue'
import RouteTemplate from 'ember-route-template'

export const ApplicationErrorPage: TOC<unknown> = <template>
  {{! This error page will be rendered outside of the application template, it'll be pretty bare (no sidenav, etc) }}
  <div data-test-application-error>
    <ErrorsApplicationErrorPage class="mx-auto my-8 max-w-xl" />
  </div>

  {{! Render flash messages here, so that any error flashes that occurred will still appear }}
  <FlashQueue />
</template>

export default RouteTemplate(ApplicationErrorPage)
